import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
  marginBottom: theme.spacing.expanded,
}));

export const Banner = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 12,
  backgroundColor: theme.colors.backgroundAbnormalFlag,
  color: theme.colors.textPrimary,
  borderRadius: 12,
  padding: theme.spacing.standard,
}));

export const Content = styled.div({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  gap: 4,
});

export const StyledLink = styled.a(({ theme }) => ({
  width: "fit-content",
  color: theme.colors.brandActionBlue,
  borderBottom: `1px solid ${theme.colors.brandActionBlue}`,
}));

export const CloseButton = styled.button(({ theme }) => ({
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.colors.textPrimary,
  flex: "0 0 auto",
  "&:hover": {
    opacity: 0.7,
  },
}));
